import React from "react";

import { TeaserSlider } from "../../../../components/teaser-components/TeaserSlider/TeaserSlider";
import { TeaserGrid } from "../../../../components/teaser-components/TeaserGrid/TeaserGrid";
import { Button } from "../../../../components/Button";

import * as styles from "./TeaserView.module.less";
import { useIsTablet } from "../../../../lib/hooks/mediaQueries";

export function TeaserView({
    display,
    semanticOfTeaserHeadline,
    teaser = [],
    hasLightBackground = true
}) {
    const isMobile = useIsTablet();
    const idButtonPrev = "button-prev-content-teaser";
    const idButtonNext = "button-next-content-teaser";

    switch (display) {
        case "standard":
            return (
                <TeaserGrid
                    teaserList={teaser}
                    sliderOnMobile={true}
                    hasLightBackground={hasLightBackground}
                    semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                    maxElements={3}
                />
            );
        case "slider":
            if (teaser.length <= 3) {
                return (
                    <TeaserGrid
                        teaserList={teaser}
                        sliderOnMobile={true}
                        hasLightBackground={hasLightBackground}
                        semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                    />
                );
            }

            return (
                <div>
                    {!isMobile && (
                        <>
                            <div className={styles.mediaSliderControls}>
                                <Button
                                    id={idButtonPrev}
                                    type="prev"
                                    icon="arrowLeft"
                                />
                                <Button
                                    id={idButtonNext}
                                    type="next"
                                    icon="arrowRight"
                                />
                            </div>
                            <TeaserSlider
                                hasLightBackground={hasLightBackground}
                                idButtonPrev={idButtonPrev}
                                idButtonNext={idButtonNext}
                                teaser={teaser}
                                semanticOfTeaserHeadline={
                                    semanticOfTeaserHeadline
                                }
                                maxTeaserWidth={430}
                                withoutGrid={true}
                            />
                        </>
                    )}
                    {isMobile && (
                        <TeaserGrid
                            hasLightBackground={hasLightBackground}
                            teaserList={teaser}
                            sliderOnMobile={true}
                            semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                            maxElements={teaser.length}
                        />
                    )}
                </div>
            );
        case "grid":
            return (
                <TeaserGrid
                    hasLightBackground={hasLightBackground}
                    teaserList={teaser}
                    sliderOnMobile={true}
                    semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                    maxElements={teaser.length}
                />
            );
        default:
            return null;
    }
}
